import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot
} from '@angular/router';
import { map, take } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { selectAuthToken } from '../store/auth.store';
import { RootState } from '../../store/store.state';

@Injectable()
export class AuthInvalidGuard implements CanActivate {
    constructor(private store: Store<RootState>, private router: Router) {}

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        return this.store.pipe(
            select(selectAuthToken),
            take(1),
            map(jwt => {
                if (typeof jwt === 'string' && jwt.length > 0) {
                    return false;
                } else {
                    return true;
                }
            })
        );
    }
}
